var map = {
	"./Ajit_Rajwade/1.jpg": 1103,
	"./Ajit_Rajwade/2.jpg": 1104,
	"./Ajit_Rajwade/3.jpg": 1105,
	"./Ajit_Rajwade/grp_pic.jpg": 1106,
	"./Ajit_Rajwade/poster.jpg": 1107,
	"./Ajit_Rajwade/vahida_maam.jpg": 1108,
	"./Algowar/1.jpg": 1109,
	"./Algowar/2.jpg": 241,
	"./ArtSciencePublication/1.png": 1110,
	"./ArtSciencePublication/2.png": 1111,
	"./ArtSciencePublication/3.png": 1112,
	"./ArtSciencePublication/4.png": 1113,
	"./CP/poster.png": 235,
	"./CodeQuest/1.jpg": 1114,
	"./CodeQuest/2.jpg": 242,
	"./CodeQuest2/2.jpg": 243,
	"./CodeQuest2/4.jpg": 1115,
	"./CodeQuest2/5.jpg": 1116,
	"./CodeQuest4/CodeQuest4.0_Winners.jpeg": 135,
	"./CodeQuest4/award_ceremony.jpeg": 1117,
	"./CodeQuest4/live_event1.jpeg": 1118,
	"./CodeQuest4/live_event3.jpeg": 1119,
	"./CodeQuest5/Codequest_dates.jpg": 232,
	"./CodeQuest5/Codequest_poster.jpg": 231,
	"./CodeQuest5/codequest_winners.jpeg": 1120,
	"./CodeQuest6/CQ6Poster.jpeg": 236,
	"./CodeQuest6/img1.jpeg": 1121,
	"./CodeQuest6/img2.jpeg": 1122,
	"./CodeQuest6/img3.jpeg": 1123,
	"./Code_to_Compete_2021/1.png": 1124,
	"./Code_to_Compete_2021/2.png": 1125,
	"./Code_to_Compete_2021/3.png": 1126,
	"./Code_to_Compete_2022/img1.png": 1127,
	"./Code_to_Compete_2022/img2.png": 1128,
	"./Code_to_Compete_2022/img3.png": 1129,
	"./Code_to_Compete_2022/img4.png": 1130,
	"./Code_to_Compete_2022/img5.png": 1131,
	"./Code_to_Compete_2022/img6.png": 1132,
	"./Code_to_Compete_2023/ctc_event.jpg": 1133,
	"./Code_to_Compete_2023/ctc_event_0.jpeg": 1134,
	"./Code_to_Compete_2023/ctc_event_2.jpeg": 1135,
	"./Code_to_Compete_2023/ctc_event_3.jpeg": 1136,
	"./Code_to_Compete_2023/ctc_event_4.jpeg": 1137,
	"./Codequest3/img1.jpeg": 1138,
	"./Codequest3/img2.jpeg": 244,
	"./Codequest3/img3.jpeg": 1139,
	"./DevTools/Dev1.png": 1140,
	"./DevTools/Dev2.png": 1141,
	"./DevTools/Dev3.png": 1142,
	"./Engg_awesome/img1.jpg": 1143,
	"./Engg_awesome/img2.jpeg": 1144,
	"./Engg_awesome/img3.jpeg": 1145,
	"./ExpertTalk/1.jpg": 1146,
	"./ExpertTalk/2.jpg": 1147,
	"./Git/1.jpg": 1148,
	"./Git/2.jpg": 1149,
	"./Git/3.jpg": 1150,
	"./Git/4.jpg": 1151,
	"./Green/1.jpg": 1152,
	"./Green/2.jpg": 1153,
	"./Green/3.jpg": 1154,
	"./Green/4.jpg": 1155,
	"./Inaugration/1.jpg": 1156,
	"./Inaugration/2.jpg": 1157,
	"./Inspiron.png": 140,
	"./Inspiron/Inspiron1.png": 1158,
	"./Inspiron/Inspiron2.png": 1159,
	"./Inspiron/Inspiron3.png": 1160,
	"./Inspiron/Inspiron4.png": 1161,
	"./Inspiron/Inspiron5.png": 1162,
	"./Inspiron/Inspiron6.png": 1163,
	"./Inspiron/Inspiron7.png": 1164,
	"./Inspiron/Inspiron8.png": 1165,
	"./Inspiron/Inspiron_winners.png": 245,
	"./Inspiron2/Inspiron.png": 1166,
	"./Inspiron2/first_image.png": 1167,
	"./Inspiron2/fourth_img.png": 1168,
	"./Inspiron2/second_image.png": 1169,
	"./Inspiron2/third_image.png": 1170,
	"./Inspiron5/eval.jpg": 1171,
	"./Inspiron5/poster.png": 224,
	"./Inspiron5/results.jpg": 1172,
	"./Inspiron5/round2.jpeg": 1173,
	"./Inspiron_2025/cogni_1.jpeg": 1174,
	"./Inspiron_2025/csi_team.jpeg": 1175,
	"./Inspiron_2025/inspiron_poster.jpeg": 1176,
	"./Inspiron_2025/inspiron_presentation.jpg": 1177,
	"./Inspiron_2025/mini_audi_1.jpeg": 1178,
	"./Inspiron_2025/mini_audi_2.jpg": 1179,
	"./Intel/img1.png": 1180,
	"./Intel/img2.jpeg": 1181,
	"./Intel/img3.jpeg": 1182,
	"./Intel/img5.png": 1183,
	"./Intel/intel.png": 1184,
	"./Intel/program.jpeg": 1185,
	"./InternshipUnplugged2025/InternshipPressureUnplugged.png": 234,
	"./InternshipUnplugged2025/eventPoster.jpeg": 1186,
	"./InternshipUnplugged2025/posterNew.jpeg": 1187,
	"./InternshipUnplugged2025/speakers.jpeg": 1188,
	"./InternshipUnplugged2025/speakersNew.jpeg": 1189,
	"./IntroToCompProg_25/grpPic.jpeg": 1190,
	"./IntroToCompProg_25/pic1.jpeg": 1191,
	"./IntroToCompProg_25/poster.jpeg": 1192,
	"./LectureSeries/LectureSeriesImg1.jpeg": 1193,
	"./LectureSeries/LectureSeriesImg2.jpeg": 1194,
	"./LectureSeries/LectureSeriesImg3.jpeg": 1195,
	"./LectureSeries/LectureSeriesImg4.PNG": 1196,
	"./LectureSeries/LectureSeriesPoster.png": 1197,
	"./MERN/1.jpg": 1198,
	"./MERN/2.jpg": 1199,
	"./MERN/3.jpg": 1200,
	"./NationalCodingWeek2026/Picture1.jpg": 1201,
	"./NationalCodingWeek2026/Picture10.jpg": 1202,
	"./NationalCodingWeek2026/Picture11.jpg": 1203,
	"./NationalCodingWeek2026/Picture12.jpg": 1204,
	"./NationalCodingWeek2026/Picture13.jpg": 1205,
	"./NationalCodingWeek2026/Picture2.jpg": 1206,
	"./NationalCodingWeek2026/Picture3.jpg": 1207,
	"./NationalCodingWeek2026/Picture4.jpg": 1208,
	"./NationalCodingWeek2026/Picture5.jpg": 1209,
	"./NationalCodingWeek2026/Picture6.jpg": 1210,
	"./NationalCodingWeek2026/Picture7.jpg": 1211,
	"./NationalCodingWeek2026/Picture8.jpg": 1212,
	"./NationalCodingWeek2026/Picture9.jpg": 1213,
	"./NationalCodingWeek2026/poster.png": 237,
	"./ODLC/1.jpg": 1214,
	"./ODLC/2.jpg": 1215,
	"./ODLC/3.jpg": 1216,
	"./ODLC/4.jpg": 1217,
	"./ODLC/5.jpg": 1218,
	"./ODLCpython/1.jpg": 1219,
	"./ODLCpython/2.jpg": 1220,
	"./ODLCpython/3.jpg": 1221,
	"./ODLCpython/4.jpg": 1222,
	"./SYForDummies25/SYDummies25-1.png": 1223,
	"./SYForDummies25/SYDummies25-2.png": 1224,
	"./SYForDummies25/SYDummies25-3.jpg": 1225,
	"./SYForDummies25/SYDummies25-4.jpg": 1226,
	"./SY_dummies_23.jpg": 1227,
	"./SY_for_Dummies26/Sy_for_Dummies1.jpeg": 1228,
	"./SY_for_Dummies26/Sy_for_Dummies2.jpeg": 1229,
	"./SY_for_Dummies26/Sy_for_Dummies3.jpeg": 1230,
	"./SY_for_Dummies26/sy_for_dummies.jpeg": 192,
	"./Scrapping/1.jpg": 1231,
	"./Scrapping/2.jpg": 1232,
	"./Scrapping/3.jpg": 1233,
	"./Scrapping/4.jpg": 1234,
	"./Symposium/ODS1.jpeg": 1235,
	"./Symposium/ODS2.jpeg": 1236,
	"./Symposium/ODS3.jpeg": 1237,
	"./Symposium/ODS4.jpeg": 1238,
	"./TY&SYForDummies/Doubt session.jpeg": 1239,
	"./TY&SYForDummies/SY DSA II.jpeg": 1240,
	"./TY&SYForDummies/SY for dummies.jpeg": 1241,
	"./TY&SYForDummies/TY OS.jpeg": 1242,
	"./TY&SYForDummies/TY for dummies.jpeg": 1243,
	"./TY&SYForDummies/dummies_1.jpg": 1244,
	"./TY&SYForDummies/dummies_2.jpg": 1245,
	"./TY&SYForDummies/dummies_slide_1.png": 1246,
	"./TY&SYForDummies/handover.jpg": 1247,
	"./TY&SYForDummies/survivingForDummiesSY.jpeg": 1248,
	"./TY&SYForDummies/survivingForDummiesTY.jpeg": 1249,
	"./TY&SYForDummies/sy_dummies_ppt_pic_1.png": 1250,
	"./TY&SYForDummies/sy_dummies_ppt_pic_2.png": 1251,
	"./TY&SYForDummies/sy_dummies_ppt_pic_3.png": 1252,
	"./TY_DUMMIES_2025/computer_organisation.jpeg": 1253,
	"./TY_DUMMIES_2025/sy_dummies.jpeg": 1254,
	"./TY_DUMMIES_2025/ty_dummies.jpeg": 1255,
	"./TY_dummies_23.jpg": 1256,
	"./Upcoming/CodeQuest-1.jpeg": 1257,
	"./Upcoming/CodeQuest-2.jpeg": 1258,
	"./Upcoming/CodeQuest-3.jpeg": 1259,
	"./Upcoming/CodeQuest-4.jpeg": 1260,
	"./Upcoming/CodeQuest2.0_Sliding_Image.png": 1261,
	"./Upcoming/Inspiron'22SlidingImage.png": 1262,
	"./Upcoming/Lecture_Series.png": 1263,
	"./Upcoming/Webscape.jpeg": 1264,
	"./Upcoming/calender.png": 1265,
	"./Upcoming/clock.png": 1266,
	"./Upcoming/download.png": 1267,
	"./Upcoming/inspiron22winners.png": 1268,
	"./Upcoming/poster.jpeg": 1269,
	"./Upcoming/poster.png": 1270,
	"./Upcoming/quote.png": 1271,
	"./Upcoming/register.png": 1272,
	"./Upcoming/sympo.png": 1273,
	"./Upcoming/webscape_2023.jpeg": 1274,
	"./WebScape/Round1.jpg": 1275,
	"./WebScape/Round2 - img1.jpg": 1276,
	"./WebScape/Round2 - img2.jpg": 1277,
	"./WebScape/WebScape_new.png": 1278,
	"./WebScape/Winner1.png": 1279,
	"./WebScape/Winner2.png": 1280,
	"./WebScape/Winner3.png": 1281,
	"./WebScape_23/first_winner.jpg": 1282,
	"./WebScape_23/poster.jpeg": 1283,
	"./WebScape_23/round2.jpeg": 1284,
	"./WebScape_23/round2_1.jpeg": 1285,
	"./WebScape_23/second_winner.jpg": 1286,
	"./WebScape_23/third_winner.jpg": 1287,
	"./WebScape_new.png": 1288,
	"./Web_Design/w1.png": 1289,
	"./Web_Design/w2.png": 1290,
	"./Web_Design/w3.png": 1291,
	"./Webscape.jpeg": 1292,
	"./Webscape_25/image.png": 1293,
	"./Webscape_25/poster.png": 1294,
	"./Webscape_25/roundOne.png": 1295,
	"./Webscape_25/roundTwo.png": 1296,
	"./Webscape_25/winners.png": 1297,
	"./Webscape_26/Round1.jpeg": 1298,
	"./Webscape_26/Round2.JPG": 1299,
	"./Webscape_26/Webscape.png": 238,
	"./Webscape_26/group.jpeg": 1300,
	"./Webscape_26/poster.jpeg": 1301,
	"./Webscapes_24/Keynote-Ajit_Rajwade.png": 1302,
	"./Webscapes_24/Webscapes_poster.png": 1303,
	"./Webscapes_24/judge.jpg": 1304,
	"./Webscapes_24/poster_2.png": 1305,
	"./Webscapes_24/round-1_2.jpg": 1306,
	"./Webscapes_24/webscape_24_final.jpg": 1307,
	"./Webscapes_24/webscape_24_round-1.jpg": 1308,
	"./Webscapes_24/webscape_24_runner_up.jpg": 1309,
	"./Webscapes_24/webscape_24_winner.jpg": 1310,
	"./byjus/1.png": 1311,
	"./byjus/2.png": 1312,
	"./byjus/3.png": 1313,
	"./byjus/4.png": 1314,
	"./code_quest_4.jpeg": 1315,
	"./codequest3.0.jpg": 1316,
	"./codetocompete.jpeg": 1317,
	"./codetocompete_2024/avdhut.jpeg": 1318,
	"./codetocompete_2024/code_to_compete_2024.jpeg": 1319,
	"./codetocompete_2024/pradnyesh.jpeg": 1320,
	"./codetocompete_2024/vedanshi.jpeg": 1321,
	"./copy.png": 1322,
	"./engineering_is_awesome.jpg": 1323,
	"./gandhi_jayanthi.jpeg": 1324,
	"./git2020/1.jpg": 1325,
	"./git2020/2.jpg": 1326,
	"./hack-the-hackathon/1.png": 1327,
	"./hack-the-hackathon/2.png": 1328,
	"./hack-the-hackathon/3.png": 1329,
	"./hack-the-hackathon/4.png": 1330,
	"./img.jpg": 1331,
	"./independenceday.jpeg": 1332,
	"./ins_winner.png": 246,
	"./inspiron_poster.png": 223,
	"./intel.png": 1333,
	"./mira_session.jpg": 233,
	"./sy_dummies_ppt.jpeg": 1334,
	"./ty_dummies_ppt.jpeg": 1335,
	"./winner.jpeg": 1336
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1102;